

export const fieldValidationMessage = {
    'valueMissing': () => 'Este campo é obrigatório.',
    'tooShort': value => `Este campo deve ter no mínimo ${value.validations.minlength} caracteres.`,
    'tooLong': value => `Este campo deve ter no máximo ${value.validations.maxlength} caracteres.`,
    'rangeUnderflow': value => `Valor mínimo permitido é ${value.validations.min}.`,
    'rangeOverflow': value => `Valor máximo permitido é ${value.validations.max}.`,
    'patternMismatch': value => `${value.label} inválido!`,
    'typeMismatch': value => `${value.label} inválido!`,
  }

export const tipoDocImagem = {
  Frente: 1,
  Verso: 2,
  Comprovante: 4
}

export const limiteTamanhoArquivo = {
  Identificacao: 3,
  Outros: 6
}